import React, { FunctionComponent } from 'react';
import RPForm from './RPForm/RPForm';
import useStyles from './ResetPassword.styles';

const ResetPassword: FunctionComponent = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <RPForm />
    </div>
  );
};

export default ResetPassword;
